import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "mb-4" };
const _hoisted_2 = {
    id: "outgoing-composer-title",
    class: "text-h6 text-primary font-weight-bold"
};
const _hoisted_3 = {
    key: 0,
    class: "text-body-2 text-medium-emphasis",
    "data-testid": "outgoing-composer-recipient"
};
const _hoisted_4 = { class: "text-body-1 font-weight-bold mb-1" };
const _hoisted_5 = { class: "d-flex flex-wrap ga-2" };
import { computed, ref } from "vue";
import OutgoingFaxEditor from "@/components/OutgoingFaxEditor.vue";
import OutgoingEmailEditor from "@/components/OutgoingEmailEditor.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OutgoingComposer',
    props: {
        action: {},
        orderInfo: {},
        sendMethod: {},
        methodToggleVisible: { type: Boolean, default: false },
        faxNumber: { default: undefined },
        emailAddresses: { default: () => [] },
        emailSubject: { default: "" },
        attachmentOptions: { default: () => [] },
        templateOptions: { default: () => [] },
        preselectedAttachment: { default: undefined },
        faxSendButtonText: { default: "Send Fax" },
        emailSendButtonText: { default: "Send Email" },
        supportingDocuments: { default: () => [] },
        attachSupportingDocsFaxEnabled: { type: Boolean, default: false },
        followUpVisible: { type: Boolean, default: false },
        sentMethods: { default: () => [] },
        errors: { default: () => [] },
        sending: { type: Boolean, default: false }
    },
    emits: ["update:sendMethod", "fax-complete", "email-complete", "pre-send", "signature-redraw-required", "template-selected", "continue", "close"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const rootEl = ref(null);
        const deferSend = computed(() => props.action === "prescriber");
        const heading = computed(() => (props.action === "prescriber" ? "Send to prescriber" : "Send to plan"));
        const recipient = computed(() => {
            if (props.action !== "prescriber")
                return "";
            const { providerFirstName, providerLastName, providerTitle } = props.orderInfo;
            const name = [providerFirstName, providerLastName].filter(Boolean).join(" ");
            return name && providerTitle ? `${name}, ${providerTitle}` : name;
        });
        const otherMethod = computed(() => (props.sendMethod === "email" ? "fax" : "email"));
        const sentSummary = computed(() => `Queued for the prescriber by ${props.sentMethods.join(" and ")}.`);
        function selectMethod(method) {
            emit("update:sendMethod", method);
        }
        function onFaxComplete(payload) {
            emit("fax-complete", payload);
        }
        function onEmailComplete(payload) {
            emit("email-complete", payload);
        }
        function onPreSend(resolve, reject, options) {
            emit("pre-send", resolve, reject, options);
        }
        function onTemplateSelected(template) {
            emit("template-selected", template);
        }
        /** Scroll the composer to the top of its scroll container and move focus to it. */
        function reveal() {
            rootEl.value?.scrollIntoView({ behavior: "smooth", block: "start" });
            rootEl.value?.focus({ preventScroll: true });
        }
        __expose({ reveal });
        return (_ctx, _cache) => {
            const _component_v_progress_linear = _resolveComponent("v-progress-linear");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn_toggle = _resolveComponent("v-btn-toggle");
            return (_openBlock(), _createElementBlock("section", {
                ref_key: "rootEl",
                ref: rootEl,
                class: "outgoing-composer",
                tabindex: "-1",
                "aria-labelledby": "outgoing-composer-title",
                "data-testid": "outgoing-composer"
            }, [
                _createElementVNode("header", _hoisted_1, [
                    _createElementVNode("h2", _hoisted_2, _toDisplayString(heading.value), 1),
                    (recipient.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(recipient.value), 1))
                        : _createCommentVNode("", true)
                ]),
                (__props.sending)
                    ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                        key: 0,
                        indeterminate: "",
                        color: "primary",
                        rounded: "",
                        class: "mb-4",
                        "data-testid": "outgoing-composer-sending"
                    }))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.errors, (error, index) => {
                    return (_openBlock(), _createBlock(_component_v_alert, {
                        key: index,
                        type: "error",
                        variant: "tonal",
                        density: "compact",
                        class: "mb-4",
                        "data-testid": "outgoing-composer-error"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error), 1)
                        ]),
                        _: 2
                    }, 1024));
                }), 128)),
                (__props.followUpVisible)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 1,
                        type: "success",
                        variant: "tonal",
                        "data-testid": "prescriber-follow-up"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(sentSummary.value), 1),
                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-body-2 mb-3" }, "Send it to the prescriber another way too?", -1)),
                            _createElementVNode("div", _hoisted_5, [
                                (__props.methodToggleVisible)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 0,
                                        color: "primary",
                                        variant: "flat",
                                        "prepend-icon": otherMethod.value === 'email' ? 'mdi-email' : 'mdi-fax',
                                        "data-testid": "prescriber-follow-up-other",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('continue', otherMethod.value)))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(" Also send by " + _toDisplayString(otherMethod.value), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["prepend-icon"]))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_btn, {
                                    variant: "outlined",
                                    "data-testid": "prescriber-follow-up-same",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (emit('continue', __props.sendMethod)))
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(" Send another " + _toDisplayString(__props.sendMethod), 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_btn, {
                                    variant: "text",
                                    "data-testid": "prescriber-follow-up-done",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (emit('close')))
                                }, {
                                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                            _createTextVNode("Done", -1)
                                        ]))]),
                                    _: 1
                                })
                            ])
                        ]),
                        _: 1
                    }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (__props.methodToggleVisible)
                            ? (_openBlock(), _createBlock(_component_v_btn_toggle, {
                                key: 0,
                                "model-value": __props.sendMethod,
                                mandatory: "",
                                class: "mb-4",
                                color: "primary",
                                variant: "outlined",
                                "onUpdate:modelValue": selectMethod
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_btn, { value: "fax" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { start: "" }, {
                                                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                        _createTextVNode("mdi-fax", -1)
                                                    ]))]),
                                                _: 1
                                            }),
                                            _cache[7] || (_cache[7] = _createTextVNode(" Send Fax ", -1))
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_btn, { value: "email" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { start: "" }, {
                                                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                        _createTextVNode("mdi-email", -1)
                                                    ]))]),
                                                _: 1
                                            }),
                                            _cache[9] || (_cache[9] = _createTextVNode(" Send Email ", -1))
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["model-value"]))
                            : _createCommentVNode("", true),
                        (__props.sendMethod === 'fax')
                            ? (_openBlock(), _createBlock(OutgoingFaxEditor, {
                                key: 1,
                                title: "",
                                types: [],
                                "order-info": __props.orderInfo,
                                "to-fax-number": __props.faxNumber,
                                "attachment-options": __props.attachmentOptions,
                                "frontend-templates": __props.templateOptions,
                                "preselected-attachment": __props.preselectedAttachment,
                                "send-button-text": __props.faxSendButtonText,
                                "defer-send": deferSend.value,
                                "send-disabled": __props.sending,
                                "supporting-documents": __props.supportingDocuments,
                                "attach-supporting-docs-fax-enabled": __props.attachSupportingDocsFaxEnabled,
                                onOnComplete: onFaxComplete,
                                onOnPreSend: onPreSend,
                                onOnSignatureRedrawRequired: _cache[3] || (_cache[3] = ($event) => (emit('signature-redraw-required'))),
                                onOnFrontendTemplateSelected: onTemplateSelected
                            }, null, 8, ["order-info", "to-fax-number", "attachment-options", "frontend-templates", "preselected-attachment", "send-button-text", "defer-send", "send-disabled", "supporting-documents", "attach-supporting-docs-fax-enabled"]))
                            : _createCommentVNode("", true),
                        (__props.sendMethod === 'email')
                            ? (_openBlock(), _createBlock(OutgoingEmailEditor, {
                                key: 2,
                                title: "",
                                types: [],
                                "order-info": __props.orderInfo,
                                "to-emails": __props.emailAddresses,
                                "default-subject": __props.emailSubject,
                                "attachment-options": __props.attachmentOptions,
                                "frontend-templates": __props.templateOptions,
                                "preselected-attachment": __props.preselectedAttachment,
                                "send-button-text": __props.emailSendButtonText,
                                "defer-send": deferSend.value,
                                "send-disabled": __props.sending,
                                "supporting-documents": __props.supportingDocuments,
                                onOnComplete: onEmailComplete,
                                onOnPreSend: onPreSend,
                                onOnFrontendTemplateSelected: onTemplateSelected
                            }, null, 8, ["order-info", "to-emails", "default-subject", "attachment-options", "frontend-templates", "preselected-attachment", "send-button-text", "defer-send", "send-disabled", "supporting-documents"]))
                            : _createCommentVNode("", true),
                        (__props.action === 'plan' && __props.sendMethod === 'fax')
                            ? (_openBlock(), _createBlock(_component_v_alert, {
                                key: 3,
                                type: "info",
                                variant: "tonal",
                                prominent: "",
                                class: "mt-4"
                            }, {
                                prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, { size: "large" }, {
                                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                _createTextVNode("mdi-information", -1)
                                            ]))]),
                                        _: 1
                                    })
                                ]),
                                default: _withCtx(() => [
                                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-body-1 font-weight-bold" }, " Please verify this is the correct fax number for the insurance provider where the prior authorization will be sent. ", -1))
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ], 64))
            ], 512));
        };
    }
});
